import clsx from "clsx";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import { Icon } from "../../../../../../components";
import MenuSection from "./MenuSection";

import { LayoutInfo } from "../../../layout-editor/@types";
import styles from "./layout-action.module.scss";

type Props = {
  user: Array<LayoutInfo>;
  shared: Array<LayoutInfo>;
  rl: Array<LayoutInfo>;
  path: string;
  selected?: { id: number; type: string };
  onClick: (id: number, type: string) => void;
};

const LayoutActionDropdown = ({
  user,
  shared,
  rl,
  path,
  selected,
  onClick
}: Props) => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  const handleToggle = () => {
    setShow(prev => !prev);
  };

  return (
    <Dropdown
      data-testid="layout-actions-dropdown"
      show={show}
      onToggle={handleToggle}
      align="end"
      id={styles.dropdown}
      className={clsx("primary")}
    >
      <Dropdown.Toggle className={styles.toggle} variant="link">
        <Icon name="configuration-a" className={styles.toggle_icon} />
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.menu}>
        <MenuSection
          title="Personal Layouts"
          layouts={user ?? []}
          selected={selected?.id}
          onClick={id => onClick(id, "user")}
        />
        <MenuSection
          title="Team Layouts"
          layouts={shared ?? []}
          selected={selected?.id}
          onClick={id => onClick(id, "shared")}
        />
        <MenuSection
          title="RL Layouts"
          layouts={rl ?? []}
          selected={selected?.id}
          onClick={id => onClick(id, "rl")}
        />
        <Dropdown.Divider className={styles.divider} />
        <Dropdown.Item
          className={styles.manage_layouts}
          as={Link}
          to={path}
          state={{ from: pathname }}
        >
          Manage Layouts
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LayoutActionDropdown;
